import { query_bed_change_record_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-bedchangerecord-config';

import { reactive } from 'vue';
import { getDateTime } from '@/utils/function';

const None = null;
const True = true;
const False = false;

export default () => {
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'remoteselect',
        name: 'shop_id',
        label: '执行门店',
        disabled: !!current_shop,
        placeholder: '请选择执行门店',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-shop',
      },
      {
        type: 'remoteselect',
        name: 'bed_id',
        label: '使用床位',
        disabled: false,
        placeholder: '请选择使用床位',
        datasourceType: 'remote',
        mode: 'default',
        allowClear: true,
        modalType: 'mjstore-bed',
      },
      {
        type: 'input',
        name: 'order_used_record__customer__name',
        label: '会员姓名',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写会员姓名',
      },
      {
        type: 'input',
        name: 'order_used_record__project__name',
        label: '项目名称',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写项目名称',
      },
      {
        type: 'rangepicker',
        name: 'start_datetime',
        label: '服务开始时间',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        showTime: true,
        placeholder: '请选择服务开始时间',
      },
      {
        type: 'rangepicker',
        name: 'end_datetime',
        label: '服务结束时间',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        showTime: true,
        placeholder: '请选择服务结束时间',
      },
    ],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      shop_id: current_shop?.id,
      bed_id: null,
      bed__name: null,
      order_used_record__customer__name: null,
      order_used_record__project__name: null,
      start_datetime: null,
      end_datetime: null,
    }),
  };
  const search_options = {
    is_active: [
      { value: None, name: '全部' },
      {
        value: True,
        name: '可用',
      },
      { value: False, name: '作废' },
    ],
  };

  const edit_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const edit_model_config_options = {};

  const update_model_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'horizontal',
      col: config.creatCol,
    },
    fields: [],
    rules: {},
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
    }),
  };
  const update_model_config_options = {};

  const titleList = {
    title: '床位变动记录管理',
    addModalTitle: '新建床位变动记录',
    updateTitle: '修改床位变动记录',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  const baseColumns: TableColumn[] = [
    {
      title: '序号',
      dataIndex: 'index',
      width: 50,
    },

    {
      title: '耗单号',
      width: 150,
      dataIndex: 'order_used_record__order_code',
      checked: true,
    },
    {
      title: '项目名称',
      width: 150,
      dataIndex: 'order_used_record__project__name',
      checked: true,
    },
    {
      title: '耗单门店',
      width: 150,
      dataIndex: 'order_used_record__shop__name',
      checked: true,
    },
    {
      title: '会员姓名',
      width: 150,
      dataIndex: 'order_used_record__customer__name',
      checked: true,
    },
    {
      title: '床位编号',
      width: 150,
      dataIndex: 'bed__name',
      checked: true,
    },
    {
      title: '服务开始时间',
      width: 150,
      dataIndex: 'start_datetime',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '服务结束时间',
      width: 150,
      dataIndex: 'end_datetime',
      checked: true,
      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
    {
      title: '创建日期',
      width: 150,
      dataIndex: 'create_time',
      checked: true,

      content: (record: any, text: any) => {
        return getDateTime(text);
      },
    },
  ];
  const newSlotList: any = [];
  Object.assign(newSlotList, slotList);
  newSlotList.push({
    type: 'custom',
    slotName: 'is_active',
    field_true: '可用',
    field_false: '作废',
  });

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_bed_change_record_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
